import React, { useEffect, useRef } from 'react';
// import * as mediaPlayer from './index.js';
const mediaPlayer = require('./index.js');
import './audioMediaPlayer.scss';
import './index.css';

export interface IProps {
    url: string;
    type: 'audio' | 'video';
}

export function AudioMediaPlayer(props: IProps) {
    const placeHolderEl = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!placeHolderEl.current) {
            return;
        }

        const playerOptions = {
            parent: placeHolderEl.current,
            url: props.url,
        };
        const player: any = new mediaPlayer.MediaPlayer(props.type, playerOptions);

        return () => {
            if (!!player) {
                player.pause();
                player.destroy();
            }
        };
    }, []);

    return (
        <div className="question-title-media">
            <div ref={placeHolderEl}></div>
        </div>
    );
}
